import { Component, Vue, Inject} from "vue-property-decorator";
import { TranslateResult } from "vue-i18n";


@Component
export default class BeforeUnload extends Vue {
    @Inject() i18n!: (key: string, values?: unknown) => TranslateResult;

    constructor()
    {
        super();
        this.onBeforeUnload = this.onBeforeUnload.bind(this);
    }

    private onBeforeUnload(): string
    {
        return this.i18n('form-dirty-on-leave-page-confirm-body').toString();
    }


    setBeforeUnload(){
        window.onbeforeunload = this.onBeforeUnload;
        window.onunload = this.onBeforeUnload;
    }

    unsetBeforeUnload(){
        window.onbeforeunload = null;
        window.onunload = null;
    }
}
